module.exports = __webpack_public_path__ + "img/email.138b8423.png";